(function() {
  'use strict';

    $('.js-backtotop').on('click', function (e) {
      e.preventDefault();

      $('html,body').animate({
        scrollTop: 0
      }, 700);

      if ($('#parallax_origin').length)
        $('#parallax_origin').animate({
          scrollTop: 0
        }, 700);
    });

})();
